import { useSelector } from 'react-redux';

import ItemNoEdit from 'common/components/item/ItemNoEdit';

const ManualProductSummary = (props) => {
  const { club, clubSignup } = props;
  const settings = useSelector((state) => state.setting);
  // if (page === 'Signup') {
  //   return <div dangerouslySetInnerHTML={{ __html: club.content }} />;
  // }
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: club.content }} />
      <br />
      <div className="c7-cart-items c7-cart-items--club-shipment">
        {clubSignup.manualItems.map((item) => {
          const newItem = item;
          let clubItem;
          if (club.type === 'Controlled Subscription') {
            clubItem = club.controlledSubscription.items.find(
              (i) => i.sku === item.sku
            );
          }
          if (club.type === 'Subscription') {
            clubItem = club.subscription.items.find((i) => i.sku === item.sku);
          }
          newItem.productTitle = clubItem.productTitle;
          newItem.productVariant = clubItem.productVariant;
          newItem.price = clubItem.price;
          newItem.image = clubItem.image;

          return (
            <ItemNoEdit item={newItem} key={item.id} settings={settings} />
          );
        })}
      </div>
    </>
  );
};

export default ManualProductSummary;
